import { AcceptedJobOffers } from "@/features/jobs/accepted-job-offers";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const viewModeSchema = z.enum(["list", "calendar"]).catch("calendar");
const calendarViewSchema = z.enum(["agenda", "week", "day"]).catch("agenda");

function JobsPage() {
  return <AcceptedJobOffers />;
}

export const Route = createFileRoute("/_provider/provider/jobs/active/")({
  component: JobsPage,
  validateSearch: z.object({
    view: viewModeSchema.optional(),
    calendarView: calendarViewSchema.optional(),
  }),
});
